import React, { useState, useEffect } from 'react';
import { BelongsCreatedByRefField, FieldTypes } from 'drapcode-constant';
import CustomRadio from '../../../../common/ui/CustomRadio';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import ToggleButton from '../../../../common/ui/ToggleButton';

const ShowLookupField = ({
  collections,
  collection,
  filter,
  enableLookup,
  handleLookupChange,
  enableLookupSetting,
}) => {
  const [refCollections, setRefCollections] = useState({});
  const { fields } = collection;
  const refFieldsCollection = fields.filter((field) =>
    BelongsCreatedByRefField.includes(field.type),
  );
  useEffect(() => {
    let { lookups } = filter;
    const collKeys = {};
    refFieldsCollection.forEach((field) => {
      collKeys[field.refCollection.collectionName] = false;
    });
    lookups = lookups || [];
    lookups.forEach((lookup) => {
      const lCollectionName = lookup.collectionName;
      if (Object.keys(collKeys).includes(lCollectionName)) {
        collKeys[lCollectionName] = true;
        if (lookup.childLookups && lookup.childLookups.length > 0) {
          lookup.childLookups.forEach(
            (childLookup) => (collKeys[`${lCollectionName}.${childLookup.collectionName}`] = true),
          );
        }
      }
    });
    setRefCollections(collKeys);
  }, []);

  const selectRefCollection = (event) => {
    const { name, checked } = event.target;
    if (!checked) {
      if (!name.includes('.')) {
        setRefCollections({ ...refCollections, [name]: checked, [`${name}.createdBy`]: false });
      } else {
        setRefCollections({ ...refCollections, [name]: checked, [`${name}.createdBy`]: checked });
      }
    } else {
      setRefCollections({ ...refCollections, [name]: checked });
    }
  };

  const showChildReference = (pField) => {
    const { refCollection, fieldName, type } = pField;
    if (type === FieldTypes.belongsTo.id) {
      return;
    }
    if (!refCollection) {
      return;
    }
    const { collectionName } = refCollection;
    const isSelected = refCollections[collectionName];
    if (!isSelected) {
      return;
    }

    const collectionDetail = collections.find((coll) => coll.collectionName === collectionName);
    if (!collectionDetail) {
      return;
    }
    const childRefFieldsCollection = collectionDetail.fields.filter(
      (field) => FieldTypes.createdBy.id === field.type,
    );

    return (
      <>
        {childRefFieldsCollection.map((field) => (
          <div className="col-md-4 col-lg-3 col-sm-6 col-xs-12 pt-1" key={field.fieldName}>
            <div className="form-check ml-4 mt-2">
              <CustomRadio label={field.fieldTitle.en} isRadio={false}>
                <input
                  type="checkbox"
                  name={`${fieldName}.${field.fieldName}`}
                  className="form-check-input"
                  checked={refCollections[`${fieldName}.${field.fieldName}`]}
                  onChange={selectRefCollection}
                />
              </CustomRadio>
            </div>
          </div>
        ))}
      </>
    );
  };

  const showParentReference = () => {
    return (
      <div className="row mx-auto">
        {refFieldsCollection.map((field) => (
          <div className="col-md-4 col-lg-3 col-sm-6 col-xs-12 pt-1 border-1" key={field.fieldName}>
            <div className="form-check ml-4 mt-2">
              <CustomRadio label={field.fieldTitle.en} isRadio={false}>
                <input
                  type="checkbox"
                  name={field.refCollection.collectionName}
                  className="form-check-input"
                  checked={refCollections[field.refCollection.collectionName]}
                  onChange={selectRefCollection}
                />
              </CustomRadio>
            </div>
            <div className="row mx-auto">{showChildReference(field)}</div>
          </div>
        ))}
        <div className="col-md-12 col-lg-12 mt-4 text-right">
          <button
            type="button"
            className="btn btn-md btn-theme-warning"
            title="Update Reference"
            onClick={() => handleLookupChange(refCollections)}
          >
            <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;Update Reference
          </button>
        </div>
      </div>
    );
  };
  return (
    <div className="row mx-auto">
      <div className="col-md-12 col-lg-12 col-sm-12">
        <ToggleButton
          name="enableLookup"
          title="Enable Lookup/Reference Data loading"
          text="Enable Lookup/Reference Data loading"
          onChange={enableLookupSetting}
          isChecked={enableLookup}
        />
        {enableLookup && showParentReference()}
      </div>
    </div>
  );
};

export default ShowLookupField;
